import type { MeshComponent } from '@seddi/scene';
import { BufferAttribute, DynamicDrawUsage } from '@seddi/three';

import { PropsDiff } from '../core/reconciler/propsDiff';
import { MeshRenderable, attachMesh } from '../renderables/meshRenderable';
import { updatePositions } from '../renderer3/deformableGeometry';
import { adaptGeometry } from '../resources/meshAdapter';
import { create as createGeometry } from '../three/core/bufferGeometry';
import { SceneReconcilerFrame } from './sceneReconcilerFrame';

/**
 *
 * @param renderable
 * @param nextProps
 * @param prevProps
 * @param frame
 */
export const update = (
  renderable: MeshRenderable,
  nextProps: MeshComponent,
  prevProps: MeshComponent | undefined,
  frame: SceneReconcilerFrame,
): boolean => {
  const resources = frame.resources;

  let dirty = false;

  const diffMesh = PropsDiff.diff(nextProps, prevProps);

  diffMesh.forEach((key) => {
    switch (key) {
      case 'mesh':
      case 'hiResMesh': {
        const nextMesh = (nextProps.hiResMesh || nextProps.mesh) as any;
        const prevMesh = (prevProps?.hiResMesh || prevProps?.mesh) as any;
        const nextMeshId = nextMesh.id;
        const prevMeshId = prevMesh?.id;

        if (nextMeshId !== prevMeshId && nextMesh.href) {
          if (resources.findMesh(nextMeshId)) {
            attachMesh(renderable, nextMeshId, resources);
            dirty = true;
          } else {
            if (!resources.hasMeshRequest(nextMeshId)) {
              resources.loadMeshDeferred(nextMesh);
            }
          }
        }
        // TODO: Rework avatar integration.
        if (nextMeshId !== prevMeshId && nextMesh.geometry) {
          const geometryDesc = adaptGeometry(nextMesh.geometry);
          const geometry = createGeometry(geometryDesc);
          // Flag position buffer dynamic.
          (geometry.getAttribute('position') as BufferAttribute).setUsage(DynamicDrawUsage);
          renderable.geometry = geometry;
          renderable.mesh.geometry = geometry;
        }
        // Avatar pose deformation.
        if (nextMesh.geometry !== prevMesh?.geometry && renderable.geometry) {
          updatePositions(renderable.geometry, nextMesh.geometry.position);
        }

        break;
      }
      default:
        break;
    }
  });

  return dirty;
};
